module.exports = __webpack_public_path__ + "img/preview-7.648a17f2.png";